import { AxiosResponse } from 'axios';

import { IAccount, IAuth, ICredentials, IOAuthApi } from '../interfaces';
import { BaseApi } from './base';
import { OAuthApiUrls } from './utils';

export class OAuthApi extends BaseApi implements IOAuthApi {
  login = (credentials: ICredentials): Promise<IAuth> => {
    return this.post(
      OAuthApiUrls.login(),
      { grant_type: 'password', ...credentials },
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        withAuth: false,
      },
    );
  };

  register = (credentials: ICredentials): Promise<void> => {
    try {
      return this.post(OAuthApiUrls.register(), credentials, { withAuth: false });
    } catch (e) {
      const res = e as AxiosResponse & { errorBodyMessage?: string };
      throw new Error(res.errorBodyMessage);
    }
  };

  checkEmailInDatabase = (email: string): Promise<void> => {
    try {
      return this.post(
        OAuthApiUrls.checkEmailInDatabase(),
        {
          username: email,
        },
        { withAuth: false },
      );
    } catch (e) {
      const res = e as AxiosResponse & { errorBodyMessage?: string; errorFields?: string[] };
      if (res.errorBodyMessage || (res.errorFields && res.errorFields.length !== 0)) {
        throw new Error(res.errorBodyMessage);
      }
      throw new Error();
    }
  };

  forgotPassword = (username: string): Promise<void> => {
    return this.post(OAuthApiUrls.forgotPassword(), { username }, { withAuth: false });
  };

  fetchAccount = (): Promise<IAccount> => {
    return this.get(OAuthApiUrls.fetchAccount());
  };

  editAccount = (account: IAccount): Promise<void> => {
    return this.patch(OAuthApiUrls.fetchAccount(), {
      firstName: account.firstName,
      lastName: account.lastName,
      telephone: account.telephone,
    });
  };

  logout = (): Promise<void> => {
    return this.delete(OAuthApiUrls.logout());
  };
}
